import React, { useState, useEffect } from "react"
import "./EmbedContent.style.scss"
interface Props {
  content: string | null;
}

interface VkPlaylistArgs {
  elementId: string;
  ownerId: number;
  playlistId: number;
  hash: string;
}

// ВК меняет формат сниппета: кавычки вокруг id и хеша бывают и одинарные, и
// двойные, а после хеша может идти объект настроек. Хвост вызова игнорируем.
const vkRegex =
  /VK\.Widgets\.Playlist\(\s*(["'])(.+?)\1\s*,\s*(-?\d+)\s*,\s*(\d+)\s*,\s*(["'])(.*?)\5/i
const block = "embed-content"

// openapi.js подключается с async, поэтому window.VK может быть ещё не готов
const VK_RETRY_MS = 300
const VK_MAX_ATTEMPTS = 20

const EmbedContent = (props: Props): JSX.Element => {
  const { content } = props
  const [currentFrame, setCurrentFrame] = useState<any>()
  const [vkArgs, setVkArgs] = useState<VkPlaylistArgs | null>(null)

  const errorFrame = (message: string): JSX.Element => (
    <div className={`${block}__error`}>{message}</div>
  )

  useEffect(() => {
    if (!content) {
      setCurrentFrame(undefined)
      setVkArgs(null)

      return
    }

    const vkMatch = content.match(vkRegex)

    if (vkMatch) {
      const [, , elementId, ownerId, playlistId, , hash] = vkMatch
      const nextArgs: VkPlaylistArgs = {
        elementId,
        ownerId: Number(ownerId),
        playlistId: Number(playlistId),
        hash
      }

      setCurrentFrame(<div className={`${block}__vk`} id={elementId}></div>)
      // не пересоздаём виджет, пока правки в поле не меняют сам плейлист
      setVkArgs(prev =>
        prev &&
        prev.elementId === nextArgs.elementId &&
        prev.ownerId === nextArgs.ownerId &&
        prev.playlistId === nextArgs.playlistId &&
        prev.hash === nextArgs.hash
          ? prev
          : nextArgs
      )

      return
    }

    setVkArgs(null)

    if (content.match(/<iframe/i)) {
      setCurrentFrame(
        <div
          dangerouslySetInnerHTML={{
            __html: `${content}`
          }}
        />
      )

      return
    }

    setCurrentFrame(errorFrame("Некорректное значение, посмотрите подсказку"))
  }, [content])

  useEffect(() => {
    if (!vkArgs) {
      return
    }

    let cancelled = false
    let timer: number | undefined

    const renderWidget = (attempt: number): void => {
      if (cancelled) {
        return
      }

      const container = document.getElementById(vkArgs.elementId)

      if (container && window.VK?.Widgets?.Playlist) {
        container.innerHTML = ""
        window.VK.Widgets.Playlist(
          vkArgs.elementId,
          vkArgs.ownerId,
          vkArgs.playlistId,
          vkArgs.hash
        )

        return
      }

      if (attempt >= VK_MAX_ATTEMPTS) {
        setCurrentFrame(
          errorFrame("Не удалось загрузить плеер ВКонтакте, обновите страницу")
        )

        return
      }

      timer = window.setTimeout(() => renderWidget(attempt + 1), VK_RETRY_MS)
    }

    renderWidget(0)

    return (): void => {
      cancelled = true
      window.clearTimeout(timer)
    }
  }, [vkArgs])

  return <>{currentFrame}</>
}

export default EmbedContent
